module.exports = __webpack_public_path__ + "img/vrbox-bg.af6b3be1.jpg";